import React, { lazy, Suspense, useContext } from 'react';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { LicenseInfo } from '@mui/x-license-pro';

import 'dayjs/locale/it';
import 'dayjs/locale/de';
import 'dayjs/locale/nl';
import 'dayjs/locale/pl';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';

import Main from './Main';
import Theme from './Theme';
// import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing";
import ModuleBookingManagement from './pages/modules/ModuleBookingManagement';
import ScrollToTop from './components/utils/ScrollToTop';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AppContext } from './utils/appContext';
import dayjs from 'dayjs';

const Step1 = lazy(() => import('./pages/step1'));
const Step2 = lazy(() => import('./pages/step2'));
const Step3 = lazy(() => import('./pages/step3'));
const Accepted = lazy(() => import('./pages/payment/accepted'));
const Denied = lazy(() => import('./pages/payment/denied'));
const Maintenance = lazy(() => import('./pages/errors/maintenance'));

/*Sentry.init({
	dsn: "https://af78d2717f04493cbdf2281dc072331e@o315193.ingest.sentry.io/5712913",
	integrations: [new Integrations.BrowserTracing()],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
});*/

dayjs.Ls.it.weekStart = 1;
dayjs.Ls.en.weekStart = 1;
dayjs.Ls.de.weekStart = 1;
dayjs.Ls.pl.weekStart = 1;
dayjs.Ls.fr.weekStart = 1;
dayjs.Ls.nl.weekStart = 1;

function App() {
  const appContext = useContext(AppContext);
  LicenseInfo.setLicenseKey(
    '114d05c80a9ba50cb481592640835636Tz03NzI4NixFPTE3Mjk3NzA0MTcwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
  );

  return (
    <>
      <Box pb={5}>
        <HashRouter hashType={'hashbang'}>
          <ScrollToTop />
          <Main>
            <Theme>
              <Suspense
                fallback={
                  <Backdrop open={true} style={{ zIndex: 99 }}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                }>
                <LocalizationProvider
                  adapterLocale={appContext.language}
                  dateAdapter={AdapterDayjs}>
                  <Switch>
                    <Route exact path="/search/:search?" component={Step1} />
                    <Route exact path="/book/:search?" component={Step2} />
                    <Route exact path="/payment" component={Step3} />
                    <Route exact path="/accepted" component={Accepted} />
                    <Route exact path="/denied" component={Denied} />
                    <Route exact path="/maintenance" component={Maintenance} />
                    <Route path="/booking-management" component={ModuleBookingManagement} />
                    <Route path="/">
                      <Redirect to="/search" />
                    </Route>
                  </Switch>
                </LocalizationProvider>
              </Suspense>
            </Theme>
          </Main>
        </HashRouter>
      </Box>
    </>
  );
}

export default App;
